import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import MuiContainer from '@mui/material/Container';
import { default as LinkComponent } from 'components/Link';

export const Container = styled(MuiContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: theme.spacing(4),
  paddingTop: theme.spacing(4),
  '@media (min-width: 650px)': {
    paddingBottom: theme.spacing(8),
    paddingTop: theme.spacing(8)
  }
}));

export const LinkContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(3)
}));

export const Link = styled(LinkComponent)(({ theme }) => ({
  alignItems: 'center',
  borderBottom: '1px solid transparent',
  boxSizing: 'border-box',
  color: theme.color.grey[700],
  display: 'inline-flex',
  fontSize: theme.fontSize.large,
  padding: theme.spacing(0, 2, 1),
  '&.active': {
    borderColor: theme.color.primary.main,
    color: theme.color.primary.main
  }
}));
